import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import Dexie from 'dexie';

import {DexieService} from "./dexie.service";
import {PK} from "../../models/models";

@Injectable()
export class PKLocalService {
  table: Dexie.Table<PK, number>;

  constructor(private dexieService: DexieService) {
    this.table = this.dexieService.table('pks');
    this.table.mapToClass(PK);
  }

  public static deleteCurrentPk(): void {
    localStorage.removeItem('currentPK');
  }

  public static deletePreviousPk(): void {
    localStorage.removeItem('previousPK');
  }

  public static getCurrentPk(): PK {
    return JSON.parse(localStorage.getItem('currentPK'));
  }

  public static getPreviousPk(): PK {
    return JSON.parse(localStorage.getItem('previousPK'));
  }

  public static setCurrentPk(pk: PK): void {
    localStorage.setItem('currentPK', JSON.stringify(pk));
  }

  public static setPreviousPk(pk: PK): void {
    localStorage.setItem('previousPK', JSON.stringify(pk));
  }

  private static sortByNumber(a, b): number {
    return Number(a) - Number(b);
  }

  private static toObservable(dexiePromise): Observable<any> {
    return Observable.fromPromise(Promise.resolve(dexiePromise));
  }

  public bulkAdd(pks): Dexie.Promise<number|void> {
    return this.table.bulkAdd(pks)
      .catch(e => console.warn('duplicates are ignored', e));
  }

  public clear(): Dexie.Promise<void> {
    return this.table.clear();
  }

  public count(): Observable<number> {
    return PKLocalService.toObservable(this.table.count());
  }

  public findNumbersStartingByPKNumber(pkNumber: string, limit?: number): Observable<number[]> {
    let query = this.table
      .where('number')
      .startsWith(pkNumber)
      .limit(limit)
      .uniqueKeys(pks => pks.sort(PKLocalService.sortByNumber));
    return PKLocalService.toObservable(query);
  }

  public findNumbersMultipleOf5StartingByPKNumber(pkNumber: string, limit?: number): Observable<number[]> {
    let query = this.table
      .where('number')
      .startsWith(pkNumber)
      .limit(limit)
      .filter(pk => Number(pk.number) % 5 === 0)
      .uniqueKeys(pks => pks.sort(PKLocalService.sortByNumber));
    return PKLocalService.toObservable(query);
  }

  public findByNumberAndLocation(_pk: PK): Observable<PK> {
    let query = this.table
      .where('number')
      .equals(_pk.number.toString())
      .and(pk => pk.way == _pk.way && pk.line.id == _pk.line.id && pk.potential == _pk.potential)
      .first();
    return PKLocalService.toObservable(query).map(
      (pk: PK) => Object.assign(new PK(), pk)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/local-data-services/pk-local.service.ts